import {
  ExperienceIcon,
  EducationIcon,
  ArrowTopRightAccentIcon,
  PhoneIcon,
  EmailIcon,
  CandidatePortfolioIcon,
} from 'assets';
import { CandidateProfileItem } from 'view/pages/candidates/components';
import { useMediaQuery } from '@mui/material';
import { theme } from 'view/themes/theme';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import * as S from './styled';

const CandidateProfileBlock = ({ data, jobPostId = null, roleName, getJobSeekerProfileById }) => {
  const matches = useMediaQuery(theme.breakpoints.down('desktop'));
  return (
    <S.CandidateProfileBlock isJobSeeker={roleName === RolesEnum.JOB_SEEKER}>
      <S.CandidateProfileBlockHeader>
        <CandidateProfileItem
          candidate={data}
          roleName={roleName}
          getJobSeekerProfileById={getJobSeekerProfileById}
          jobPostId={jobPostId}
        />
      </S.CandidateProfileBlockHeader>
      {jobPostId &&
      data?.applicationStatus &&
      data?.applicationStatus?.initialMessage &&
      data?.applicationStatus?.type === 'APPLY' ? (
        <S.QualificationsContainer>
          <S.QualificationsTitle>Cover Letter</S.QualificationsTitle>
          <S.CoverLetterContent>
            <S.CoverLetterContentItem>
              <CandidatePortfolioIcon />
              <div>{data?.applicationStatus?.initialMessage}</div>
            </S.CoverLetterContentItem>
          </S.CoverLetterContent>
        </S.QualificationsContainer>
      ) : null}
      <S.QualificationsContainer>
        <S.QualificationsTitle>
          {matches ? 'Qualifications & Skills' : 'Qualifications & \n Skills'}
        </S.QualificationsTitle>
        <S.QualificationsContent>
          <S.ReusableTextBlock>
            <S.ReusableTextBlockTitle>Qualifications</S.ReusableTextBlockTitle>
            <S.ReusableTextBlockContent>
              {data?.qualifications?.length > 0 ? (
                data?.qualifications?.map((el) => {
                  return <S.ReusableTextBlockDesc key={el.id}>{el.name}</S.ReusableTextBlockDesc>;
                })
              ) : (
                <p>No Qualifications added</p>
              )}
            </S.ReusableTextBlockContent>
          </S.ReusableTextBlock>
          <S.ReusableTextBlock>
            <S.ReusableTextBlockTitle>Technical Skills</S.ReusableTextBlockTitle>
            <S.ReusableTextBlockContent>
              {data?.skills?.length > 0 &&
              data?.skills?.filter((item) => {
                return item.group === 'Hard Skills';
              }).length > 0 ? (
                data?.skills
                  ?.filter((item) => {
                    return item.group === 'Hard Skills';
                  })
                  ?.map((hardSkill) => {
                    return (
                      <S.ReusableTextBlockDesc key={hardSkill.id}>
                        {hardSkill.name}
                      </S.ReusableTextBlockDesc>
                    );
                  })
              ) : (
                <p>No Hard Skills added</p>
              )}
            </S.ReusableTextBlockContent>
          </S.ReusableTextBlock>
          <S.ReusableTextBlock>
            <S.ReusableTextBlockTitle>Soft Skills</S.ReusableTextBlockTitle>
            <S.ReusableTextBlockContent>
              {data?.skills?.length > 0 &&
              data?.skills?.filter((item) => {
                return item.group === 'Soft Skills';
              }).length > 0 ? (
                data?.skills
                  ?.filter((item) => {
                    return item.group === 'Soft Skills';
                  })
                  ?.map((softSkill) => {
                    return (
                      <S.ReusableTextBlockDesc key={softSkill.id}>
                        {softSkill.name}
                      </S.ReusableTextBlockDesc>
                    );
                  })
              ) : (
                <p>No Soft Skills added</p>
              )}
            </S.ReusableTextBlockContent>
          </S.ReusableTextBlock>
        </S.QualificationsContent>
      </S.QualificationsContainer>
      {data?.workExperience?.length > 0 ? (
        <S.QualificationsContainer>
          <S.QualificationsTitle>Work Experience</S.QualificationsTitle>
          <S.WorkExperienceContent>
            {data?.workExperience?.map((el) => {
              return (
                <S.WorkExperienceContentItem key={el.id}>
                  <ExperienceIcon />
                  <div>
                    <S.WorkExperienceContentItemTitle>
                      {el?.companyName || 'No company name'}
                    </S.WorkExperienceContentItemTitle>
                    <S.WorkExperienceContentItemProfession>
                      {el?.jobTitle || 'No job title'} (
                      {el?.positionType?.name || 'No position type'})
                    </S.WorkExperienceContentItemProfession>
                    <S.WorkExperienceContentItemDate>
                      {el.startDateMonth} {el.startDateYear} -{' '}
                      {el.isCurrentCompany ? 'Present' : `${el.endDateMonth} ${el.endDateYear}`}
                    </S.WorkExperienceContentItemDate>
                    <S.WorkExperienceContentItemDesc>
                      {el.responsibilities}
                    </S.WorkExperienceContentItemDesc>
                  </div>
                </S.WorkExperienceContentItem>
              );
            })}
          </S.WorkExperienceContent>
        </S.QualificationsContainer>
      ) : null}
      {data?.education?.length > 0 ? (
        <S.QualificationsContainer>
          <S.QualificationsTitle>Education</S.QualificationsTitle>
          <S.WorkExperienceContent>
            {data?.education?.map((el) => {
              return (
                <S.WorkExperienceContentItem key={el.id}>
                  <EducationIcon />
                  <div>
                    <S.WorkExperienceContentItemTitle>
                      {el?.organization || 'No organization'}
                    </S.WorkExperienceContentItemTitle>
                    <S.WorkExperienceContentItemProfession>
                      {el?.title || '---'} ({el?.education?.name})
                    </S.WorkExperienceContentItemProfession>
                    <S.WorkExperienceContentItemDate>
                      {el.startDateMonth} {el.startDateYear} - {el.endDateMonth} {el.endDateYear}{' '}
                      {/* (1yr 11 month) */}
                    </S.WorkExperienceContentItemDate>
                    <S.WorkExperienceContentItemDesc>
                      {el?.description || 'No description'}
                    </S.WorkExperienceContentItemDesc>
                  </div>
                </S.WorkExperienceContentItem>
              );
            })}
          </S.WorkExperienceContent>
        </S.QualificationsContainer>
      ) : null}
      {data?.certificates?.length > 0 ? (
        <S.QualificationsContainer style={{ borderBottom: 'none' }}>
          <S.QualificationsTitle>Certifications</S.QualificationsTitle>
          <S.WorkExperienceContent>
            {data?.certificates?.map((el) => {
              return (
                <S.WorkExperienceContentItem key={el.id}>
                  <EducationIcon />
                  <div>
                    <S.WorkExperienceContentItemTitle>
                      {el?.organization || 'No organization'}
                    </S.WorkExperienceContentItemTitle>
                    <S.WorkExperienceContentItemProfession>
                      {el?.title || 'No title'}
                    </S.WorkExperienceContentItemProfession>
                    <S.WorkExperienceContentItemLink
                      onClick={() => {
                        window.open(el.certificateUrl, '_blank');
                      }}
                    >
                      View Certificate <ArrowTopRightAccentIcon />
                    </S.WorkExperienceContentItemLink>
                  </div>
                </S.WorkExperienceContentItem>
              );
            })}
          </S.WorkExperienceContent>
        </S.QualificationsContainer>
      ) : null}
      <S.Footer>
        <S.CandidateContactCardMainItem>
          <PhoneIcon />
          <p>{data?.phone || 'No phone number'}</p>
        </S.CandidateContactCardMainItem>
        <S.CandidateContactCardMainItem>
          <EmailIcon />
          <p>{data?.email || 'No Email'}</p>
        </S.CandidateContactCardMainItem>
      </S.Footer>
    </S.CandidateProfileBlock>
  );
};

export default CandidateProfileBlock;
